export const RoutesPath = {
  //Quid
  QUID_HOMEPAGE: '/quid/:quid',
  QUID_MENU: '/quid/:quid/:restaurant/menu/:menu',

  //Standard
  LINK_HOMEPAGE: '/menu/:link_alias',
  LINK_LOCATION: '/menu/:link_alias/location-service-available/:restaurant/:dits/:menu',
  LINK_MENU: '/menu/:link_alias/menu/:restaurant/:dits/:menu',
  LINK_RECAP: '/menu/:link_alias/order-recap/:restaurant/:dits/:menu',
  LINK_INFO_DETAILS: '/menu/:link_alias/info-details/:restaurant/:dits/:menu/:mode',
  LINK_CONFIRM_ORDER: '/menu/:link_alias/confirm-order/:restaurant/:dits/:menu',
  LINK_WAITING_APPROVAL: '/menu/:link_alias/waiting-order-approval/:restaurant/:dits/:menu/:requestId',
  LINK_THANKS: '/menu/:link_alias/thanks/:restaurant/:dits/:menu',
  LINK_SIGNIN: '/menu/:link_alias/signin/:restaurant/:dits/:menu',
  LINK_PAYMENT: '/menu/:link_alias/payment/:restaurant/:dits/:menu',
}
